module.exports = __webpack_public_path__ + "static/img/y-3.90492695.png";